export const MAX_MIXPANEL_STRING_CHARS = 255;
export const EDITOR_VERSION = 'E2';
// Session storage item used for tracking which feature caused upgrade
export const MP_FEATURE_SESSION_STORAGE = 'mixpanel_feature';
// common accessibility checker labels
export const CHECKER_LABELS = {
  documentLanguage: 'Document Language',
  documentTitle: 'Document Title',
  alternativeText: 'Alternative Text',
  imageTexts: 'Images of Text',
  logicalReadingOrder: 'Logical Reading Order',
  headings: 'Headings',
  colorContrast: 'Color Contrast',
  useOfColor: 'Use of Color',
  links: 'Links',
  tables: 'Tables',
  textSize: 'Text Size',
};
